import { render, staticRenderFns } from "./OrderInfoCustomer.vue?vue&type=template&id=b2ba9ef8&"
import script from "./OrderInfoCustomer.vue?vue&type=script&lang=js&"
export * from "./OrderInfoCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports